import { render } from "./ElFoundationHeader.vue?vue&type=template&id=d6bf161c&scoped=true&lang=html"
import script from "./ElFoundationHeader.vue?vue&type=script&lang=js"
export * from "./ElFoundationHeader.vue?vue&type=script&lang=js"

import "./ElFoundationHeader.vue?vue&type=style&index=0&id=d6bf161c&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6bf161c"]])

export default __exports__